import {BrickContext} from 'olympe';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import {ezprOrange} from '../../../_helpers';
import CloseIcon from '@mui/icons-material/Close';
import {DialogContent} from '@mui/material';
import {MasterDataDropdown} from '../../utils/MasterDataDropdown.jsx';
import {ControlledEZPRSelect} from '../../utils/ControlledEZPRSelect.jsx';
import {checkLabelValueObject} from '../../../../utils/checkObjects';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {requestStores} from '../../../ListOfPREditors.brick.jsx';
import {LAMBDA_NAMES} from '../../../../utils/constants';

/**
 * @param {FillInInfoContent.propTypes} props
 * @return {Element}
 */
export const FillInInfoContent = (props) => {
    const getMasterData = props.context.get(LAMBDA_NAMES.GET_MASTER_DATA);

    const useRequestStore = requestStores.get(props.prTag);
    const [companyCode, setCompanyCode, pslCompanyCodes] = useRequestStore((state) => [state.companyCode, state.setCompanyCode, state.pslCompanyCodes]);
    const [purchaseOrganization, setPurchaseOrganization] = useRequestStore((state) => [state.purchaseOrganization, state.setPurchaseOrganization]);
    const userIdToCallSAPAPIs = useRequestStore((state) => state.userIdToCallSAPAPIs);

    const [disableSaveButton, setDisableSaveButton] = useState(!companyCode.value || !purchaseOrganization.value);

    const handleCompanyCodeChange = (newValue) => {
        setCompanyCode(newValue);
        setDisableSaveButton(!newValue.value || !purchaseOrganization.value);
    };

    const handlePurchaseOrganizationChange = (newValue) => {
        setPurchaseOrganization(newValue);
        setDisableSaveButton(!newValue.value || !companyCode.value);
    };

    const handleSave = () => {
        props.onClose();
    };

    return (
        <>
            <div className={'pr-popup-header'}>
                <DialogTitle>Please fill in the <b>Company Code</b> and <b>Purchase Organization</b> fields first.</DialogTitle>
                <div className={'pr-editor-search-supplier-popup-dropdown-and-icon-block'}>
                    <IconButton
                        aria-label="close"
                        onClick={props.onCancel}
                        sx={{
                            color: ezprOrange,
                        }}>
                        <CloseIcon
                            sx={{
                                width: '50px',
                                height: '50px',
                            }}
                        />
                    </IconButton>
                </div>
            </div>
            <DialogContent>
                <div className={'pr-editor-search-supplier-popup-missing-info'}>
                    <p>Company code: *</p>
                    {
                        pslCompanyCodes.length === 0 ? (
                            <MasterDataDropdown
                                recentlyUsed
                                error={!companyCode.label}
                                property={'Company Code'}
                                selectedValue={companyCode}
                                context={props.context}
                                getMasterData={getMasterData}
                                onChange={handleCompanyCodeChange}
                                filterQueryWithSearch
                                userId={userIdToCallSAPAPIs}
                            />
                        ) : (
                            <ControlledEZPRSelect
                                value={companyCode}
                                options={[...pslCompanyCodes].sort((a, b) => a.value.localeCompare(b.value))}
                                placeholder={'Please choose the Company code'}
                                handleChange={(_, newVal) => {
                                    const newLabelValue = checkLabelValueObject(newVal);
                                    handleCompanyCodeChange(newLabelValue);
                                }}
                            />
                        )
                    }
                    <p>Purchase organization: *</p>
                    <MasterDataDropdown
                        error={!purchaseOrganization.label}
                        property={'Purchase Organization'}
                        selectedValue={purchaseOrganization}
                        context={props.context}
                        getMasterData={getMasterData}
                        onChange={handlePurchaseOrganizationChange}
                        filterQueryWithSearch
                        userId={userIdToCallSAPAPIs}
                        recentlyUsed
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button className={'pr-editor-search-supplier-popup-btn' + (disableSaveButton ? '-disabled' : '')} onClick={handleSave} disabled={disableSaveButton}>
                    Save
                </Button>
            </DialogActions>
        </>

    );
};

FillInInfoContent.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
